import { render, staticRenderFns } from "./MainTag.vue?vue&type=template&id=5cee447e&scoped=true&"
import script from "./MainTag.vue?vue&type=script&lang=js&"
export * from "./MainTag.vue?vue&type=script&lang=js&"
import style0 from "./MainTag.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MainTag.vue?vue&type=style&index=1&id=5cee447e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee447e",
  null
  
)

export default component.exports